import './_error.scss';

function Error() {
    return(
        <div className="error-page-body">
            <h2>404</h2>
            <p>Oups! La page que vous demandez n'existe pas.</p>
            <a href="/">Retourner à la page d'accueil</a>
        </div>
    )
}

export default Error